import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

export const useDeletePfiConfig = (options = {}) => {
  const res = useMutation(
    (configId) =>
      http.delete(
        HTTP_ENDPOINTS.patientFiIntegration.deletePfiConfig(configId),
      ),
    options,
  );

  return res;
};
